var journalsList = [
    {
        "year": "2023",
        "yearWork": [
            {
                "data": `UHWA Hewage, R Sinha, and M. Asif Naeem.Privacy-preserving data (stream) mining techniques and their impact on data mining accuracy: a systematic literature review. Artificial Intelligence Review, pages 1-38, 2023.`,
                "pdflink": `https://link.springer.com/article/10.1007/s10462-023-10425-3`
            },
          
        ]
    },
    {
        "year": "2022",
        "yearWork": [
            
            {
                "data": `Benjamin Denham, Edmund MK Lai, Roopak Sinha, and M. Asif Naeem. Witan: Unsupervised labelling function generation for assisted data programming. Proceedings of the VLDB Endowment, 15(11):2334-2347, 2022.`,
                "pdflink": `https://dl.acm.org/doi/abs/10.14778/3551793.3551797`
            },
            {
                "data": `Muhammad Usama, M. Asif Naeem, and Farhaan Mirza. Multi-class skin lesions classification using deep features. Sensors, 22(21):8311, 2022.`,
                "pdflink": `https://www.mdpi.com/1424-8220/22/21/8311`
            },
            {
                "data": `Widana Kankanamge Darsha Jayamini, Farhaan Mirza, M. Asif Naeem, and Amy Hai Yan Chan. State of asthma-related hospital admissions in new zealand and predicting length of stay using machine learning. Applied Sciences, 12(19), 2022. `,
                "pdflink": `https://www.mdpi.com/2076-3417/12/19/9890`
            },
            {
                "data": `M. Asif Naeem, Wasiullah Waqar, Farhaan Mirza, and Ali Tahir. Tinylfu-based semi-stream cache join for near-real-time data warehousing. Soft Computing, 2022.`,
                "pdflink": `https://link.springer.com/article/10.1007/s10489-021-03019-5`
            },
            {
                "data": `Rashi Bhalla, Russel Pears, M. Asif Naeem, and Farhaan Mirza. Novel Method for Optimizing Performance in Resource Constrained Distributed Data Streams, Applied Intelligence, IF=5.086, 2022`,
                "pdflink": `https://link.springer.com/article/10.1007/s00500-022-07475-0`
            },
            {
                "data": `Alhanof Almutairi, M. Asif Naeem, and Gerald Weber. Assessing User Satisfaction of Current Enterprise Systems and their Adaptability from the Perspective of Top Management, IEEE Access, IF=3.367, 2022`,
                "pdflink": `https://doi.org/10.1109/ACCESS.2021.3127950`
            },
        ]
    },
    {
        "year": "2021",
        "yearWork": [
            {
                "data": `Herman Masindano Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears. Multi-interest
                semantic changes over time in short-text microblogs. Knowledge-Based Systems, 228:107249, 2021.`,
                "pdflink": `https://doi.org/10.1016/j.knosys.2021.107249`
            },
            {
                "data": `Herman Masindano Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears. Topical affinity in short text microblogs. Information Systems, page 101662, 2020, (Q1 in SCImago, ranked A in CORE, IF=3.167)`,
                "pdflink": `https://doi.org/10.1016/j.is.2020.101662`
            },
            {
                "data": `Farrukh Zahid, Ali Tahir, Habib Ullah Khan, and M. Asif Naeem. Wind farms selection using geospatial
                technologies and energy generation capacity in gwadar. Energy Reports, 7:5857{5870, 2021.`,
                "pdflink": `https://doi.org/10.1016/j.egyr.2021.08.165`
            },
        ]
    },
    {
        "year": "2020",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Farhaan Mirza, Habib Ullah Khan, David Sundaram, Noreen Jamil, and Gerald Weber. Big data velocity management-from stream to warehouse via high performance memory optimised index join. IEEE Access, 8:195370-195384, 2020, (Q1 in SCImago, IF=3.745)`,
                "pdflink": `https://doi.org/10.1109/ACCESS.2020.3033464`
            },
            {
                "data": `Muhammad Daud Kamal, Ali Tahir, Muhammad Babar Kamal, Faisal Moeen, and M. Asif Naeem.
                A survey for the ranking of trajectory prediction algorithms on ubiquitous wireless sensors. Sensors,
                20(22):6495, 2020.`,
                "pdflink": `https://doi.org/10.3390/s20226495`
            },

            {
                "data": `Muhammad Daud Kamal, Ali Tahir, Muhammad Babar Kamal, and M. Asif Naeem Naeem. Future location prediction for emergency vehicles using big data: A case study of healthcare engineering. Journal of Healthcare Engineering, 2020, (IF=1.809)`,
                "pdflink": `https://doi.org/10.1155/2020/6641571`
            },

            {
                "data": `Muhammad Daud Kamal, Ali Tahir, Muhammad Babar Kamal, Faisal Moeen, and M. Asif Naeem. A survey for the ranking of trajectory prediction algorithms on ubiquitous wireless sensors. Sensors, 20(22):6495, 2020, (IF=3.275)`,
                "pdflink": `https://doi.org/10.3390/s20226495`
            },

            {
                "data": `M. Asif Naeem, Habib Ullah Khan, Saad Aslam, and Noreen Jamil.  Parallelisation of a cache-based stream-relation join for a near-real-time data warehouse. Electronics, 9(8):1299, 2020, (IF=2.412)`,
                "pdflink": `https://doi.org/10.3390/electronics9081299`
            },

            {
                "data": `Yiwei Feng, M. Asif Naeem, Farhaan Mirza, and Ali Tahir. Reply using past replies - a deep learning-based e-mail client. Electronics, 9(9):1353, 2020, (IF=2.412)`,
                "pdflink": `https://doi.org/10.3390/electronics9091353`
            },
        
            {
                "data": `Asif Mansoor, Muhammad Waleed Usman, Noreen Jamil, and M. Asif Naeem. Deep learning algorithm for brain-computer interface. Scientific Programming, 2020, (IF=0.963)`,
                "pdflink": `https://doi.org/10.1155/2020/5762149`
            },
    
            {
                "data": `Benjamin Denham, Russel Pears, and M. Asif Naeem. Enhancing random projection with independent and cumulative additive noise for privacy-preserving data stream mining. Expert Systems with Applications, page 113380, 2020, (Q1 in SCImago,IF=4.577)`,
                "pdflink": `https://doi.org/10.1016/j.eswa.2020.113380`
            },
            {
                "data": `Benjamin James Denham, Russel Pears, and M. Asif Naeem. HDSM: A distributed data mining approach to classifying vertically distributed data streams. Knowledge-Based Systems, pages 105{114, 2019, (Q1 in SCImago,IF=5.358)`,
                "pdflink": `hhttps://doi.org/10.1016/j.knosys.2019.105114`
            },
            {
                "data": `Amira Khattak, Noreen Jamil, M. Asif Naeem, Farhaan Mirza, et al. Data analytics in mental healthcare. Scientific Programming, 2020`,
                "pdflink": `https://doi.org/10.1155/2020/2024160`
            },
            {
                "data": `Mohammed  Alkorbi,  Noreen  Jamil, M.  Asif  Naeem,  Farhaan  Mirza,  et  al.   Evaluating  encryption algorithms for sensitive data using different storage devices. Scientific Programming, 2020`,
                "pdflink": `https://doi.org/10.1155/2020/6132312`
            },
            {
                "data": `M. Asif Naeem, Erum Mehmood, and M. G. Abbas Malik. Optimizing semi-stream cachejoin for near-real-time data warehousing. Journal of Database Management, 2020, (Q2 in SCImago, IF=0.12)`,
                "pdflink": `https://doi.org/10.4018/JDM.2020010102`
            },
        ]
    },
    {
        "year": "2019",
        "yearWork": [
            {
                "data": `Adi Darliansyah, Herman Masindano Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears. SENTIPEDE: A smart system for sentiment-based personality detection from short texts. Journal of Universal Computer Science, 2019, (Q2 in SCImago,IF=0.77)`,
                "pdflink": `https://doi.org/10.3217/jucs-025-10-1323`
            },
            {
                "data": `Huy Vuong Nguyen, M. Asif Naeem, Nuttanan Wichitaksorn, and Russel Pears. A smart system for short-term price prediction using time series models.
                Journal of Computer and Electrical Engineering, 2019. (IF=1.78).`,
                "pdflink": `https://doi.org/10.1016/j.compeleceng.2019.04.013`
            },
            {
                "data": `M. Asif Naeem. Optimisation and extension of stream-relation joins. The International Journal of Information Technology & Decision Making, 2019. (Q1 in SCImago, IF=1.755)`,
                "pdflink": `https://doi.org/10.1142/S0219622019500214`
            },
        ]
    },
    {
        "year": "2018",
        "yearWork": [
            {
                "data": `M. Safdar Munir, Imran Sarwar Bajwa, M. Asif Naeem, and Bushra Ramzan. Design and implementation of an IOT system for smart energy consumption and smart irrigation in tunnel farming. Energies, 11(12), 2018. (Q1 in SCImago)`,
                "pdflink": `https://doi.org/10.3390/en11123427`
            },
            {
                "data": `M. Asif Naeem, Aftab A Mughal, Christof Lutteroth, and Gerald Weber. A smart email client prototype for effective reuse of past replies. IEEE Access, 6(1):69453–69471, 2018. (Q1 in SCImago, IF=3.55)`,
                "pdflink": `https://doi.org/10.1109/ACCESS.2018.2878523`
            },
            {
                "data": `Wandabwa, Herman and M. Asif Naeem, Farhaan Mirza, and Russel Pears. A metamodel enabled approach for discovery of coherent topics in short text microblogs. IEEE Access, 6(1):65582–65593, 2018. (Q1 in SCImago, IF=3.55)`,
                "pdflink": `https://doi.org/10.1109/ACCESS.2018.2878441`
            },
            {
                "data": `M. Asif Naeem, Christof Lutteroth, and Gerald Weber. A memory-optimal many-to-many semi-stream join. Distributed and Parallel Databases, pages 1–27, 2018. (A in CORE, IF=1.179)`,
                "pdflink": `https://doi.org/10.1007/s10619-018-7247-z`
            },
            {
                "data": `Nguyen, Hoa and Mirza, Farhaan and M. Asif Naeem and Mansoor Baig. Falls management framework for supporting an independent lifestyle for older adults a systematic review. Aging Clinical and Experimental Research, pages 1–12, 2018. (Q2 in SCImago)`,
                "pdflink": `https://doi.org/10.1007/s40520-018-1026-6`
            },
            {
                "data": `Noreen Jamil, Farhaan Mirza, M. Asif Naeem, and Nilufar Baghaei. A refinement of an iterative orthogonal projection method. Journal of Computational and Applied Mathematics, 341:31–41, 2018. (A in ARC, IF=1.357, Q1 in SCImago) `,
                "pdflink": `https://doi.org/10.1016/j.cam.2018.02.025`
            },
            {
                "data": `Chamari I. Kithulgoda, Russel Pears, and M. Asif Naeem. The incremental fourier classifier: Leveragingthe discrete fourier transform for classifying high speed data streams. Expert Systems with Applications,97:1-17, 2018. (IF=3.928, Q1 in SCImago)`,
                "pdflink": `https://doi.org/10.1016/j.eswa.2017.12.023`
            }
        ]
    },
    {
        "year": "2017",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Christof Lutteroth, Gerald Weber (2017), "Skewed Distributions in Semi-Stream Joins: How much can Caching help?", Information Systems, 64,63-74, 2017. (ranked A* in CORE, IF=2.82, Q1 in SCImago)`,
                "pdflink": `https://doi.org/10.1016/j.is.2016.09.007`
            },
            {
                "data": `Imran Sarwar Bajwa, Fatima Karim, M. Asif Naeem, Riaz ul Amin (2017) "A Semi Supervised Approach for Catchphrase Classification in Legal Text Documents". Journal of Computers,  12(5), pp.451-461, 2017. (IF=0.17, Q3 in SCImago)`,
                "pdflink": `https://doi.org/10.17706/jcp.12.5.451-461`
            },
            {
                "data": `Perera, Rivindu, Parma Nand, and M. Asif Naeem. "Utilizing typed dependency subtree patterns for answer sentence generation in question answering systems." Progress in Artificial Intelligence, Springer, 1-15, 2017. (Q4 in SCImago)`,
                "pdflink": `https://doi.org/10.1007/s13748-017-0113-9`
            },
            {
                "data": `Imran Sarwar Bajwa, N. Mamoona Asghar, and M. Asif Naeem. Automated detection of early tropical cyclones formation in satellite images. Pakistan Journal of Science, 69(4), 2017. (IF=0.23, Q3 inSCImago)`,
                "pdflink": `https://www.researchgate.net/profile/Mamoona_Asghar2/publication/322339258_AUTOMATED_DETECTION_OF_EARLY_TROPICAL_CYCLONES_FORMATION_IN_SATELLITE_IMAGES/links/5a54e0164585152af77fd5a0/AUTOMATED-DETECTION-OF-EARLY-TROPICAL-CYCLONES-FORMATION-IN-SATELLITE-IMAGES.pdf`
            },
            {
                "data": `Imran Sarwar Bajwa, N. Mamoona Asghar, and M. Asif Naeem. Learning based improved seeded region growing algorithm for brain tumor identification. Proceeding of Pakistan Academy of Science, 54(2),2017. (IF=0.21, Q4 in SCImago)`,
                "pdflink": `http://ppaspk.org/index.php/PPAS-A/article/view/241`
            },
        ]
    },
    {
        "year": "2016",
        "yearWork": [
            {
                "data": `Imran Sarwar Bajwa, Nadeem Sarwar, and M. Asif Naeem, "Generating EXPRESS Data Models from SBVR." Proceeding of Pakistan Academy of Sciences: 53(4):381-389, 2016. (IF=0.21, Q4 in SCImago)`,
                "pdflink": `http://ppaspk.org/index.php/PPAS-A/article/view/254`
            },
            {
                "data": `M. Shahzad Akram, Imran Sarwar Bajwa, and M. Asif Naeem. A supervised approach for semantic annotation of entities in text. Science International, 28(1):237-241, 2016. (IF=1.365 )`,
                "pdflink": `http://www.sci-int.com/pdf/8360445651%20a%20237-241%20%20M.%20Shahzad%20Akram--IT--BWP--REVISED--Paid%20OK.pdf`
            },
            {
                "data": `Imran Sarwar Bajwa and M. Asif Naeem. A CBR based automated approach for reusing businessprocess models. Science International, 28(1):227-232, 2016. (IF=1.365 )`,
                "pdflink": `http://www.sci-int.com/pdf/12082985991%20a%20227-232%20Imran%20Sarwar%20Bajwaa--COMPU--BWP--PAID.pdf`
            },
            {
                "data": `M. Asif Naeem, Imran Sarwar Bajwa, and Noreen Jmail, "A Cached-Based Stream-Relation Join Operator for Semi-Stream Data Processing", International Journal of Data Warehousing and Mining (IJDWM). 12(3), pp. 14-31, 2016. (IF=0.727, Q2 in SCImago)`,
                "pdflink": `https://doi.org/10.4018/IJDWM.2016070102`
            },
            {
                "data": `N. Jamil, J. Müller, M. Asif. Naeem, C. Lutteroth, G. Weber, “Extending linear relaxation for non-square matrices and soft constraints”, Journal of Computational and Applied Mathematics, 308, (May 2016), pp. 346-360 (ranked A in ARC, IF=1.08, Q1 in SCImago)`,
                "pdflink": `https://doi.org/10.1016/j.cam.2016.05.006`
            }
        ]
    },
    {
        "year": "2014",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Noreen Jamil, “An Efficient Stream-based Join to Process End User Transactions in Real-Time Data Warehousing”, Journal of Data and Information Management (JDIM), vol. 12, no. 3, pp. 201-215, 2014. (IF=1.25, Q1in SCImago)`,
                "pdflink": `http://dline.info/fpaper/jdim/v12i3/5.pdf`
            }
        ]
    },
    {
        "year": "2013",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, “Efficient Processing of Streaming Updates with Archived Master Data in Near-Real-Time Data Warehousing”, Knowledge and Information Systems, Springer-Verlag, 2013.  (IF=0.726, Q1 in SCImago)`,
                "pdflink": `https://doi.org/10.1007/s10115-013-0653-7`
            },
            {
                "data": `Noreen Jamil, M. Asif Naeem, “Speeding Up SOR and Kaczmarz for Constraint-based GUIs with a Warm-Start Strategy”, Journal of Multimedia Processing and Technologies (JMPT), vol. 4, no. 3, pp. 179-188, 2013.`,
                "pdflink": `http://www.dline.info/jmpt/fulltext/v4n3/3.pdf`
            },
        ]
    },
    {
        "year": "2011",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, “HYBRIDJOIN for Near-real-time Data Warehousing”, International Journal of Data Warehousing and Mining (IJDWM), IGI Global, vol. 7, no. 4, pp. 21-42, 2011. (IF=0.727, Q2 in SCImago)`,
                "pdflink": `https://www.igi-global.com/article/hybridjoin-near-real-time-data/58636`
            },
            {
                "data": `Imran Sarwar Bajwa, Ahsan Ali Chaudhri, M. Asif Naeem, “Processing Large Data Sets using a Cluster Computing Framework”, Australian Journal of Basic and Applied Sciences (AJBAS), vol. 5, no. 6, pp. 1614-1618, 2011. (IF=0.126, Q4 in SCImago)`,
                "pdflink": `http://www.cs.bham.ac.uk/~isb855/papers/2011%20-%20Cluster%20%20-%20AJBAS%205(7).pdf`
            },
            {
                "data": `M. Asif Naeem, Noreen Jamil, “A Web Smart Space Framework for Intelligent Search Engines”, International Journal of Emerging Sciences, vol. 1, no. 1, pp. 1-10, 2011.`,
                "pdflink": `http://cogprints.org/7294/1/4254111.pdf`
            },
        ]
    },
]

export default journalsList;